export default __webpack_public_path__ + "static/1586-dbe044e303cbff17f9ed2dc84b4efd47.gif";